import { Grid } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import { setDate1mem, setDate2mem } from '../slices/authSlice';

const PeriodPicker = () => {
  const dispatch = useDispatch();

  const { date1mem, date2mem } = useSelector((state) => state.auth);

  const handleSetDate = (num, value) => {
    if (num === 1) {
      //дата начала периода
      dispatch(setDate1mem(value.toISO()));
    }
    if (num === 2) {
      //дата окончания периода
      dispatch(setDate2mem(value.toISO()));
    }
  };
  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
      <Grid item sm={6} md={6} xs={6} sx={{ mb: 1 }}>
        <MobileDatePicker
          // autoOk='true'
          disableFuture={true}
          // disableCloseOnSelect={false}
          value={DateTime.fromISO(date1mem)}
          onChange={(newValue) => handleSetDate(1, newValue)}
          sx={{ width: '100%' }}
        />
      </Grid>
      <Grid item sm={6} md={6} xs={6} sx={{ mb: 1 }}>
        <MobileDatePicker
          disableFuture={true}
          // disableCloseOnSelect={false}
          value={DateTime.fromISO(date2mem)}
          onChange={(newValue) => handleSetDate(2, newValue)}
          sx={{ width: '100%' }}
        />
      </Grid>
    </Grid>
  );
};

export default PeriodPicker;
